export * from './faq-page.component';
